<template>
  <div class="oil-form-container">
    <!-- 面包屑导航 - 美化 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="custom-breadcrumb">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>加油站信息</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 主卡片 - 现代圆润风格 -->
    <el-card class="modern-card" shadow="never">
      <el-form
        :inline="false"
        :model="addForm"
        :rules="rules"
        ref="formForRef"
        label-width="120px"
        autocomplete="on"
        size="medium"
        class="alipay-form"
      >
        <!-- 标签页 - 支付宝风格 -->
        <el-tabs v-model="activeName" @tab-click="handleClick" class="alipay-tabs">
          <!-- 基本信息 -->
          <el-tab-pane label="基本信息" name="first">
            <div class="form-section">
              <el-row :gutter="32">
                <el-col :span="8">
                  <el-form-item label="所属省市" prop="province_id" required>
                    <el-cascader
                      ref="cascaderAddr"
                      style="width: 100%"
                      v-model="areaList"
                      :props="propsdata"
                      :key="isResouceone"
                      @change="handleChangeAddress"
                      placeholder="请选择省市"
                      clearable
                    ></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="门店名称" prop="name" required>
                    <el-input placeholder="请输入门店名称" v-model="addForm.name"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="类别" prop="grade_id">
                    <el-select v-model="addForm.cat_id" disabled placeholder="请选择类别" style="width: 100%">
                      <el-option
                        v-for="item in cateMenus"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="32">
                <el-col :span="8">
                  <el-form-item label="门店编号">
                    <el-input placeholder="门店编号系统生成" disabled v-model="addForm.sn"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="营业执照负责人" prop="artiperson">
                    <el-input placeholder="请输入营业执照负责人" v-model="addForm.artiperson"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="入驻时间">
                    <el-date-picker
                      clearable
                      type="date"
                      placeholder="选择合同开始时间"
                      value-format="yyyy-MM-dd"
                      v-model="addForm.contract_start_time"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="32">
                <el-col :span="8">
                  <el-form-item label="联系人">
                    <el-input placeholder="请输入联系人" v-model="addForm.cont_name"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="联系电话">
                    <el-input placeholder="请输入联系电话" v-model="addForm.telephone"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="联系手机">
                    <el-input placeholder="请输入联系手机" v-model="addForm.mobile"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="32">
                <el-col :span="8">
                  <el-form-item label="业务员提成%" required>
                    <el-input placeholder="请输入业务员提成" v-model="addForm.business_rate" type="number">
                      <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="抽成比例%" required>
                    <el-input placeholder="请输入抽成比例" v-model="addForm.rate" type="number">
                      <template slot="append">%</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="32">
                <el-col :span="16">
                  <el-form-item label="地址">
                    <el-input placeholder="请输入详细地址" v-model="addForm.address"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="32">
                <el-col :span="24">
                  <el-form-item label="店铺LOGO">
                    <div class="logo-uploader" @click="showImgDoc(1,'')">
                      <i class="el-icon-camera" v-show="!addForm.logo"></i>
                      <el-image class="logo-image" v-show="addForm.logo" :src="addForm.logo" fit="cover"></el-image>
                      <div class="upload-tip">点击上传LOGO</div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="32">
                <el-col :span="24">
                  <el-form-item label="图片附件">
                    <el-upload
                      class="image-uploader"
                      drag
                      action="#"
                      :before-upload="handleBeforeUpload"
                      :on-success="uploadSuccess"
                      :auto-upload="false"
                      :on-change="uploadFile"
                      :file-list="fileList"
                      list-type="picture"
                      multiple
                    >
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                      <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="32">
                <el-col :span="24">
                  <el-form-item label="图片URL">
                    <el-input v-model="addForm.logo" placeholder="图片URL地址"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>

          <!-- 地址信息 -->
          <el-tab-pane label="地址信息" name="second">
            <div class="form-section">
              <el-row :gutter="32">
                <el-col :span="16">
                  <map-picker :formData="formData" @update="updateMap" :modelValue="location" />
                  <div class="map-actions">
                    <el-button size="small" type="primary" plain @click="showLocation">显示当前坐标</el-button>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>

          <!-- 店铺详情 -->
          <el-tab-pane label="店铺详情" name="third">
            <div class="form-section">
              <el-row>
                <el-col>
                  <div class="editor-wrapper">
                    <Toolbar
                      style="border-bottom: 1px solid #EDEFF2"
                      :editor="editor"
                      :defaultConfig="toolbarConfig"
                      :mode="mode"
                    />
                    <Editor
                      style="height: 360px; overflow-y: auto"
                      v-model="addForm.description"
                      :defaultConfig="editorConfig"
                      :mode="mode"
                      @onCreated="onCreated"
                      @onChange="onChange"
                    />
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>

          <!-- 附件资料 -->
          <el-tab-pane label="附件资料" name="fourth">
            <div class="form-section">
              <el-empty description="暂无附件资料" :image-size="120"></el-empty>
            </div>
          </el-tab-pane>
        </el-tabs>

        <!-- 底部按钮 -->
        <div class="form-actions">
          <el-button type="primary" size="medium" @click="submitForm('ruleForm')" class="submit-btn">保存</el-button>
          <el-button size="medium" @click="resetForm('ruleForm')" class="cancel-btn">返回</el-button>
        </div>
      </el-form>

      <!-- 文档选择弹窗 -->
      <eDocList
        :formData="formData1"
        :visible.sync="visible1"
        :title="title1"
        :closeForm="closeForm1"
        v-on:eventChoose="eChooseDoc"
      />
    </el-card>
  </div>
</template>

<script>
  import MapPicker from '../common/MapPicker.vue'
  import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
  import axios from 'axios'
  import moment from 'moment'
  import eDocList from "../common/eDocList";
  import CryptoJS from "crypto-js";

  export default {
    components: { MapPicker, Editor, Toolbar, eDocList },
    data() {
      return {
        formData: {},
        formData1: {},
        title1: '',
        visible1: false,
        type_img: 1,
        activeName: 'first',
        location: { lng: 118.341854, lat: 35.077435 },
        gradeList: [],
        baseUrl: '/api/',
        fileList: [],
        shopList: [],
        dicList: [],
        provinceList: [],
        addForm: {
          cat_id: 13,
          logo: '',
          id: '',
          artiperson: '',
          basic_name: "",
          work_status: '',
          status: '',
          name: '',
          sn: '',
          contract_sn: '',
          contract_start_time: '',
          contract_end_time: '',
          grade_id: '',
          province_id: "",
          city_id: "",
          district_id: "",
          sex: '',
          amount: '',
          id_code: '',
          mobile: '',
          remark: '',
          order_time: '',
          summary: "",
          manager_name: '',
          unit_name: "",
          telephone: '',
          address: '',
          cont_name: '',
          shop_id: '',
          description: '',
          shop_img: '',
          access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id'),
          proxy_id: sessionStorage.getItem('proxy_id'),
          lng: '',
          lat: '',
          business_rate: 0,
          rate: 0
        },
        ruleForm: {
          url: '',
          start_time: "",
          ad_id: '',
          ad_name: '',
          ad_link: '',
          position_id: '',
          ad_code: ''
        },
        cateMenus: [],
        editor: null,
        html: '<p>请填写店铺详情...</p>',
        toolbarConfig: {},
        editorConfig: {
          placeholder: '请输入内容...',
          MENU_CONF: {
            uploadImage: {
              customUpload: this.uploadImg
            }
          }
        },
        mode: 'default',
        rules: {
          name: [
            { required: true, message: "请输入门店名称", trigger: 'blur' }
          ],
          province_id: [
            { required: true, message: "请选择省市", trigger: 'change' }
          ],
          business_rate: [
            { required: true, message: "请输入业务员提成比例", trigger: 'blur' }
          ],
          rate: [
            { required: true, message: "请输入抽成比例", trigger: 'blur' }
          ]
        },
        areaList: [],
        isResouceone: false,
        propsdata: {
          lazy: true,
          lazyLoad(node, resolve) {
            let url = '/api/api/cmp.sys.Region_read_lz/findRegionList';
            setTimeout(() => {
              if (node.level == 0) {
                axios.post(url, {
                  access_token: sessionStorage.getItem('token'),
                  company_id: sessionStorage.getItem('company_id'),
                  parent_id: 1
                }).then((res) => {
                  if (res.data.code == 200) {
                    const nodes = res.data.data.map((item) => ({
                      value: item.id,
                      label: item.name,
                    }));
                    resolve(nodes);
                  }
                }).catch(() => {});
              }
              if (node.level == 1) {
                axios.post(url, {
                  access_token: sessionStorage.getItem('token'),
                  company_id: sessionStorage.getItem('company_id'),
                  parent_id: node.value
                }).then((res) => {
                  if (res.data.code == 200) {
                    const nodes = res.data.data.map((item) => ({
                      value: item.id,
                      label: item.name,
                    }));
                    resolve(nodes);
                  }
                }).catch(() => {});
              }
              if (node.level == 2) {
                axios.post(url, {
                  access_token: sessionStorage.getItem('token'),
                  company_id: sessionStorage.getItem('company_id'),
                  parent_id: node.value
                }).then((res) => {
                  if (res.data.code == 200) {
                    const nodes = res.data.data.map((item) => ({
                      value: item.id,
                      label: item.name,
                      leaf: true,
                    }));
                    resolve(nodes);
                  }
                }).catch(() => {});
              }
            }, 100);
          },
        },
      }
    },
    mounted() {
      this.getCateMenus();
      setTimeout(() => {
        this.html = '<p>模拟 Ajax 异步设置内容 HTML</p>';
      }, 1500);
      this.getGradeList();
      var id = this.$route.query.id;
      if (!isNaN(id) && id > 0) {
        this.addForm.id = id;
        this.getOne();
      }
    },
    methods: {
      updateMap(val) {
        this.addForm.lng = val.lng;
        this.addForm.lat = val.lat;
      },
      showImgDoc(type) {
        this.type_img = type;
        this.title1 = "图片选择";
        this.visible1 = true;
      },
      closeForm1() {
        this.visible1 = false;
      },
      eChooseDoc(id, ...params) {
        if (this.type_img == 1) {
          this.addForm.logo = params[1];
        }
      },
      handleClick() {},
      showLocation() {
        console.log('当前坐标:', this.location);
      },
      handleChangeAddress() {
        const checkedNode = this.$refs["cascaderAddr"].getCheckedNodes();
        if (checkedNode.length > 0) {
          this.addForm.province_id = checkedNode[0].path[0];
          this.addForm.city_id = checkedNode[0].path[1];
          this.addForm.district_id = checkedNode[0].path[2];
        }
      },
      getDicList() {
        const param = {
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          code: "CCT",
        };
        this.$axios.dicTable(param).then(res => {
          if (res.code == 200) this.dicList = res.data;
        }).catch(error => console.log(error));
      },
      getGradeList() {
        const param = {
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          code: "shopGrade",
        };
        this.$axios.dicListByPid(param).then(res => {
          if (res.code == 200) this.gradeList = res.data;
        }).catch(error => console.log(error));
      },
      getShopList() {
        const param = {
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
        };
        this.$axios.shopList(param).then(res => {
          if (res.code == 200) {
            this.shopList = res.data;
            this.addForm.shop_id = res.data[0].id;
            this.DataList();
          }
        }).catch(error => console.log(error));
      },
      submitForm() {
        if (this.addForm.business_rate == '' || this.addForm.rate == '' || this.addForm.business_rate == null || this.addForm.rate == null) {
          this.$message.error("请输入业务比例");
          return;
        }
        if (parseFloat(this.addForm.business_rate) == 0) {
          this.$message.error("业务员提成比例要大于0");
          return;
        }
        if (parseFloat(this.addForm.rate) == 0) {
          this.$message.error("抽成比例要大于0");
          return;
        }
        this.$refs.formForRef.validate((valid) => {
          if (valid) {
            let params = this.addForm;
            if (this.addForm.lng && this.addForm.lat) {
              params.lng = this.addForm.lng;
              params.lat = this.addForm.lat;
            }
            this.$axios.shopSaveLgs(params).then(res => {
              if (res.code == 200) {
                this.$message.success("保存成功");
                this.$router.push('/oilList');
              }
            }).catch(error => {
              this.$message.error("保存错误");
              console.log(error);
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      getOne() {
        let _this = this;
        let param = {
          access_token: _this.addForm.access_token,
          company_id: _this.addForm.company_id,
          id: _this.addForm.id
        };
        this.$axios.shopOne(param).then((res) => {
          if (res.code == 200) {
            let item = res.data;
            _this.addForm.name = item.name;
            _this.addForm.grade_id = item.grade_id ? item.grade_id : '';
            _this.addForm.shop_id = item.shop_id;
            _this.addForm.artiperson = item.artiperson;
            _this.addForm.province_id = item.province_id;
            _this.addForm.city_id = item.city_id;
            _this.addForm.district_id = item.district_id;
            _this.areaList = [item.province_id, item.city_id, item.district_id];
            if (item.description) {
              _this.addForm.description = item.description;
            }
            _this.addForm.cat_id = item.cat_id;
            _this.addForm.lng = item.lng;
            _this.addForm.lat = item.lat;
            if (item.lng && item.lat) {
              this.location = { lng: parseFloat(item.lng), lat: parseFloat(item.lat) };
            }
            _this.addForm.logo = item.logo;
            _this.addForm.cont_name = item.cont_name;
            _this.addForm.telephone = item.telephone;
            _this.addForm.mobile = item.mobile;
            _this.addForm.address = item.address;
            _this.addForm.sn = item.sn;
            _this.addForm.contract_sn = item.contract_sn;
            _this.addForm.contract_start_time = item.contract_start_time ? moment(item.contract_start_time * 1000).format('YYYY-MM-DD') : '';
            _this.addForm.contract_end_time = item.contract_end_time ? moment(item.contract_end_time * 1000).format('YYYY-MM-DD') : '';
            _this.addForm.basic_name = item.basic_name;
            _this.addForm.business_rate = item.business_rate;
            _this.addForm.rate = item.rate;
            if (_this.addForm.shop_img != '' && _this.addForm.shop_img != null) {
              var img = { name: _this.addForm.name, url: _this.addForm.shop_img };
              _this.fileList.push(img);
            }
          }
        });
      },
      async uploadFile(item) {
        let _this = this;
        let file = item.raw;
        let file_md5, file_sha1;
        await this.calculateMD5(file).then(md5 => { file_md5 = md5; });
        await this.calculateSHA1(file).then(sha1 => { file_sha1 = sha1; });
        const fileName = file.name;
        const fileSize = file.size;
        const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);
        let param_1 = {
          access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id'),
          md5: file_md5,
          sha1: file_sha1,
          size: fileSize
        };
        this.$axios.uploadOne(param_1).then(res => {
          if (res.code == 200) {
            _this.addForm.logo = res.data.url;
            var img = { name: res.data.name, url: res.data.url };
            _this.fileList.push(img);
          } else {
            let param = {
              access_token: sessionStorage.getItem('token'),
              company_id: sessionStorage.getItem('company_id')
            };
            this.$axios.getAliJsonCmp(param).then(res => {
              let data = res['data'];
              let suffix = _this.get_suffix(file.name);
              let autoname = _this.Ymdhis();
              let key = data['dir'];
              let host = data['host'];
              let path = data['path'] != null && data['path'] != undefined ? data['path'] : '';
              let request = new FormData();
              request.append('name', file.name);
              request.append("key", key + path + autoname + suffix);
              request.append("policy", data['policy']);
              request.append("OSSAccessKeyId", data['accessid']);
              request.append("success_action_status", '200');
              request.append("callback", data['callback']);
              request.append("Signature", data['signature']);
              request.append('file', file);
              axios.post(host, request, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
                var fileurl = res.data.filename;
                var fullurl = host + '/' + fileurl;
                _this.addForm.logo = fullurl;
                var img = { name: fileName, url: fullurl };
                _this.fileList.push(img);
                let upload_params = {
                  access_token: sessionStorage.getItem('token'),
                  company_id: sessionStorage.getItem('company_id'),
                  name: fileName,
                  size: fileSize,
                  ext: fileExtension,
                  md5: file_md5,
                  sha1: file_sha1,
                  path: fileurl,
                  url: fullurl,
                  status: 1,
                };
                _this.$axios.uploadSave(upload_params).then(resu => {
                  console.log(resu)
                });
              }).catch(error => console.log(error));
            });
          }
        });
      },
      readFileAsBinaryString(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
          reader.readAsBinaryString(file);
        });
      },
      async calculateMD5(file) {
        return this.readFileAsBinaryString(file).then(binaryString => {
          const words = CryptoJS.lib.WordArray.create(binaryString);
          return CryptoJS.MD5(words).toString();
        });
      },
      async calculateSHA1(file) {
        return this.readFileAsBinaryString(file).then(binaryString => {
          const words = CryptoJS.lib.WordArray.create(binaryString);
          return CryptoJS.SHA1(words).toString();
        });
      },
      resetForm() {
        this.$router.push('/oilList');
      },
      handleBeforeUpload() {},
      uploadSuccess() {},
      getCateMenus() {
        const param = {
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
        };
        this.$axios.findShopCategoryTree(param).then(res => {
          if (res.code == 200) this.cateMenus = res.data;
        }).catch(error => console.log(error));
      },
      uploadImg(file, insertFn) {
        let _this = this;
        let param = {
          access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id'),
        };
        this.$axios.getAliJsonCmp(param).then(res => {
          let data = res['data'];
          let suffix = _this.get_suffix(file.name);
          let autoname = _this.Ymdhis();
          let key = data['dir'];
          let host = data['host'];
          let path = data['path'] != null && data['path'] != undefined ? data['path'] : '';
          let request = new FormData();
          request.append('name', file.name);
          request.append("key", key + path + autoname + suffix);
          request.append("policy", data['policy']);
          request.append("OSSAccessKeyId", data['accessid']);
          request.append("success_action_status", '200');
          request.append("callback", data['callback']);
          request.append("Signature", data['signature']);
          request.append('file', file);
          axios.post('/alioss', request, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
            var fileurl = res.data.filename;
            var fullurl = host + '/' + fileurl;
            setTimeout(function() { insertFn(fullurl); }, 500);
          }).catch(error => console.log(error));
        });
      },
      onCreated(editor) {
        this.editor = Object.seal(editor);
      },
      onChange() {},
      get_suffix(filename) {
        let pos = filename.lastIndexOf('.');
        let suffix = '';
        if (pos != -1) suffix = filename.substring(pos);
        return suffix;
      },
      Ymdhis() {
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();
        return '' + year + month + day + hour + minute + second;
      },
    },
    beforeDestroy() {
      const editor = this.editor;
      if (editor == null) return;
      editor.destroy();
    },
  };
</script>

<style scoped>
/* 整体容器背景 */
.oil-form-container {
  background-color: #F5F7FA;
  min-height: 100vh;
  padding: 20px 24px 40px;
}

/* 面包屑美化 */
.custom-breadcrumb {
  margin-bottom: 20px;
}
.custom-breadcrumb >>> .el-breadcrumb__inner {
  color: #6C7A8E;
  font-weight: normal;
}
.custom-breadcrumb >>> .el-breadcrumb__inner a:hover {
  color: #1677FF;
}
.custom-breadcrumb >>> .el-breadcrumb__separator {
  color: #C0C4CC;
}

/* 主卡片圆润无边框 */
.modern-card {
  border-radius: 24px;
  border: none;
  background-color: #FFFFFF;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.04), 0 0 0 1px rgba(0, 0, 0, 0.01);
  transition: box-shadow 0.2s;
}
.modern-card >>> .el-card__body {
  padding: 28px 32px 32px;
}

/* 支付宝风格表单 */
.alipay-form >>> .el-form-item {
  margin-bottom: 22px;
}
.alipay-form >>> .el-form-item__label {
  font-weight: 500;
  color: #1E2A3A;
  font-size: 14px;
}
.alipay-form >>> .el-input__inner,
.alipay-form >>> .el-select .el-input__inner,
.alipay-form >>> .el-cascader__label,
.alipay-form >>> .el-date-editor .el-input__inner {
  border-radius: 12px;
  border: 1px solid #E4E7ED;
  transition: all 0.2s;
  height: 40px;
  line-height: 40px;
}
.alipay-form >>> .el-input__inner:focus,
.alipay-form >>> .el-select .el-input__inner:focus,
.alipay-form >>> .el-cascader__label:focus,
.alipay-form >>> .el-date-editor .el-input__inner:focus {
  border-color: #1677FF;
  box-shadow: 0 0 0 2px rgba(22,119,255,0.1);
}
.alipay-form >>> .el-input-group__append {
  border-radius: 0 12px 12px 0;
  background-color: #F8F9FC;
  border-color: #E4E7ED;
}

/* 标签页支付宝风格 */
.alipay-tabs >>> .el-tabs__header {
  margin-bottom: 28px;
}
.alipay-tabs >>> .el-tabs__nav-wrap::after {
  height: 2px;
  background-color: #EDEFF2;
}
.alipay-tabs >>> .el-tabs__item {
  font-size: 16px;
  font-weight: 500;
  color: #6C7A8E;
  padding: 0 20px;
  transition: color 0.2s;
}
.alipay-tabs >>> .el-tabs__item.is-active {
  color: #1677FF;
}
.alipay-tabs >>> .el-tabs__active-bar {
  background-color: #1677FF;
  height: 3px;
  border-radius: 3px 3px 0 0;
}
.alipay-tabs >>> .el-tabs__item:hover {
  color: #1677FF;
}

/* 表单区块间距 */
.form-section {
  padding: 8px 0 16px;
}

/* LOGO上传区域 */
.logo-uploader {
  width: 120px;
  height: 120px;
  border: 1px dashed #D9DEE4;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: #FAFBFC;
  transition: all 0.2s;
  overflow: hidden;
}
.logo-uploader:hover {
  border-color: #1677FF;
  background-color: #F0F7FF;
}
.logo-uploader i {
  font-size: 40px;
  color: #A3AFC1;
}
.logo-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.upload-tip {
  font-size: 12px;
  color: #8C9AA8;
  margin-top: 8px;
}

/* 图片上传组件美化 */
.image-uploader >>> .el-upload-dragger {
  border-radius: 20px;
  background-color: #FAFBFC;
  border: 1px dashed #D9DEE4;
  transition: all 0.2s;
}
.image-uploader >>> .el-upload-dragger:hover {
  border-color: #1677FF;
  background-color: #F0F7FF;
}
.image-uploader >>> .el-upload__tip {
  color: #8C9AA8;
  font-size: 12px;
}

/* 编辑器容器 */
.editor-wrapper {
  border: 1px solid #EDEFF2;
  border-radius: 16px;
  overflow: hidden;
  background-color: #FFFFFF;
}

/* 地图操作区 */
.map-actions {
  margin-top: 16px;
  text-align: center;
}

/* 底部按钮 */
.form-actions {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #EDEFF2;
  text-align: center;
}
.submit-btn {
  background-color: #1677FF;
  border-color: #1677FF;
  border-radius: 40px;
  padding: 10px 32px;
  font-weight: 500;
  transition: all 0.2s;
}
.submit-btn:hover {
  background-color: #0958D9;
  border-color: #0958D9;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(22,119,255,0.3);
}
.cancel-btn {
  border-radius: 40px;
  padding: 10px 32px;
  font-weight: 500;
  background-color: #FFFFFF;
  border-color: #D9DEE4;
  color: #5A6878;
}
.cancel-btn:hover {
  border-color: #1677FF;
  color: #1677FF;
  background-color: #F0F7FF;
}

/* 级联选择器深度样式调整 */
.alipay-form >>> .el-cascader__dropdown {
  border-radius: 16px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
}
.alipay-form >>> .el-cascader-node__label {
  font-size: 13px;
}

/* 空状态样式 */
.el-empty {
  padding: 60px 0;
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>